import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardCard from '../../../components/DashboardCard/DashboardCard';
import Icon from '../../../components/Icons/Icon';
import styles from './Dashboard.module.css';
import { useTranslation } from 'react-i18next';

const Dashboard: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleHelpClick = () => navigate('/');
  const handleUserClick = () => navigate('/account/profile');
  const handleBundlesClick = () => navigate('/bundles/library');
  const handlePromosClick = () => navigate('/promotions/active');
  const handleUsersClick = () => navigate('/users');

  return (
    <div>
      <div className={styles.banner} />
      <div className={styles.header}>
        <h1>{t('common.welcomeBack')}</h1>
        <div className={styles.icons}>
          <Icon iconName="HelpCircle" onClick={handleHelpClick} />
          <Icon iconName="User" onClick={handleUserClick} />
        </div>
      </div>
      <div className={styles.page}>
        <DashboardCard
          title={t('dashboard.bundleManagementTitle')}
          onViewClick={handleBundlesClick}
          className={styles.card}
          buttonAriaLabel={t('dashboard.bundleManagementAriaLabel')}
        >
          <div className={styles.bundlesMessage}>{t('dashboard.bundleManagementDescription')}</div>
        </DashboardCard>
        <DashboardCard
          title={t('dashboard.promoManagementTitle')}
          onViewClick={handlePromosClick}
          className={styles.card}
          buttonAriaLabel={t('dashboard.promoManagementAriaLabel')}
        >
          <div className={styles.bundlesMessage}>{t('dashboard.promoManagementDescription')}</div>
        </DashboardCard>
        <DashboardCard
          title={t('dashboard.userManagementTitle')}
          onViewClick={handleUsersClick}
          className={styles.card}
          buttonAriaLabel={t('dashboard.userManagementAriaLabel')}
        >
          <div className={styles.bundlesMessage}>{t('dashboard.userManagementDescription')}</div>
        </DashboardCard>
      </div>
    </div>
  );
};

export default Dashboard;
